import React from 'react'

export default function About() {
    return (
        <>
            <div className='me1' data-aos="zoom-out">

                <div className='me'>
                    <h2>Welcome To Shri Shyam <span>Interior</span></h2>
                    <p>Get the best in class interior products at the wholesale rate.
                        <br /> Let your home shines out with Shri Shyam Interior.
                    </p>

                </div>
                <div className='images'>
                    <img src="https://cdn.shopify.com/s/files/1/1288/2227/files/About-image-4.png?v=1642332926" alt="" />
                </div>
            </div>

            <div id='deliv'>
                <div className='del'>
                    <img src="https://cdn.shopify.com/s/files/1/1288/2227/files/delivery_small.png?v=1642330735" alt="" />
                    <p> <b>Free Shipping</b>
                        <br /> Product are free shipping</p>
                </div>
                <div className='del'>
                    <img src="https://cdn.shopify.com/s/files/1/1288/2227/files/technical-support_small.png?v=1642330750" alt="" />
                    <p> <b>Support 24/7</b>
                        <br /> Support 24 hours a day</p>
                </div>
                <div className='del'>
                    <img src="https://cdn.shopify.com/s/files/1/1288/2227/files/padlock_small.png?v=1642330768" alt="" />
                    <p> <b>Secure Payment</b>
                        <br /> We ensure secure payment</p>
                </div>
                <div className='del'>
                    <img src="https://cdn.shopify.com/s/files/1/1288/2227/files/money-back-guarantee_small.png?v=1642330786" alt="" />
                    <p> <b>100% Moneyback</b>
                        <br />Most product are free shipping.</p>
                </div>
            </div>

            
        </>
    );
}
